export {
    AbsoluteRouteOnlyPath,
    type AbsoluteRoutePath,
    AbsoluteRoutePathWithId,
    AbsoluteRoutePathWithServiceAndResourceId,
    AbsoluteRoutePathWithServiceId,
    type AbsoluteRouteUpdateArgs,
    isAbsoluteRouteOnlyPath,
    isAbsoluteRoutePathWithId,
    isAbsoluteRoutePathWithServiceAndResourceId,
    isAbsoluteRoutePathWithServiceId,
    isRelativeRoutePathWithId,
    RelativeRoutePathWithId,
    type RouterProps,
    type RouterState,
    type RouteUpdateArgs,
} from './Domain'
